import React from "react";
import { useGetTeamsQuery } from "../../features/team/teamsApi";
import TeamMember from "./TeamMember";

export default function TeamMembers() {
  const { data: teams, isLoading, isError } = useGetTeamsQuery();

  let content;
  if (isLoading) {
    content = <div>Loading...</div>;
  } else if (isError) {
    content = <div>Error</div>;
  } else {
    content = teams.map((team) => <TeamMember key={team.id} team={team} />);
  }

  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
}
